<script>
  import { onMount } from 'svelte'
  import { getContext } from 'svelte'
  export let type
  export let ticks
  export let scale
  export let width
  let promise = false

  let { margin } = getContext('chart')

  onMount(() => {
    promise = true
  })
</script>

{#if promise}
  {#if type === 'y'}
    {#each ticks.y as tick}
      <line
        class="grid y-grid"
        y1={scale.y(tick)}
        y2={scale.y(tick)}
        x1={margin.left}
        x2={width - margin.right}
      />
    {/each}
  {/if}
{/if}
